import React from "react";
import { RenderHtml } from "./render-html";
import { Criteria } from "@app/lib/shopify";

type Props = {
  className?: string;
  id?: string;
  criteria: Criteria;
  showTooltip?: boolean;
};

export function Badge({ criteria, showTooltip }: Props) {
  const html = `
    <x-badge>
      <script type="application/json" name="criteria">
          ${JSON.stringify(criteria)}
      </script>
      ${
        showTooltip === undefined
          ? ``
          : `<script type="application/json" name="showTooltip">
              ${showTooltip}
            </script>`
      }
    </x-badge>
  `;

  return <RenderHtml html={html} />;
}
